import React from 'react'
import { RegisterAssetData, TransferPayloadData } from 'src/constants/DataModels'
import PayloadRegisterAsset from 'src/components/Relays/Details/sections/PayloadRegisterAsset'
import AttributeTable from 'src/components/shared/AttributeTable'
import AttributeRow from 'src/components/shared/AttributeRow'
import ReactJson from 'react-json-view'
import 'src/components/Relays/Details/sections/Payload.css'
import { TransferInfo } from 'src/components/shared/TransferInfo'
import { ExplorerAssetLink } from 'src/components/shared/ExplorerAssetLink'

type Props = {
  payload_type: string
  payload:
    | TransferPayloadData
    | RegisterAssetData
    | any
  sourceBlockchain: string
  destinationBlockchain: string
}

const Payload: React.FC<Props> = ({
                                    payload_type,
                                    payload,
                                    sourceBlockchain,
                                    destinationBlockchain
                                  }) => {
  if (!payload) {
    return <div />
  }
  switch (payload_type) {
    // case 'transfer': {
    //   return <PayloadTransfer payloadData={payload} sourceBlockchain={sourceBlockchain}
    //                           destinationBlockchain={destinationBlockchain}
    //   />
    // }
    case 'register_asset': {
      return <PayloadRegisterAsset payloadData={payload} sourceBlockchain={sourceBlockchain}
                                   destinationBlockchain={destinationBlockchain}
      />
    }
    default: {
      const shouldShowTransferInfo = !!payload.transfer_amount_human
        && Number(payload.transfer_amount_human) >= 0
      return (
        <AttributeTable>
          <AttributeRow name={'Flow Type'}>{payload.flow_type}</AttributeRow>
          <AttributeRow name={'Payload Type'}>{payload_type}</AttributeRow>
          {
            shouldShowTransferInfo &&
            <>
              <AttributeRow name={'Transfer'}>

                <TransferInfo payload={payload} source_blockchain={sourceBlockchain}
                              destination_blockchain={destinationBlockchain}
                />
              </AttributeRow>
              <AttributeRow name={'Demex Denom'}>
                <ExplorerAssetLink blockchain={'carbon'} assetDenomOrAddress={payload.transfer_denom}/>
              </AttributeRow>
            </>
          }
          <AttributeRow name={'Decoded Payload'}>
            <ReactJson src={payload.decoded_payload} style={{ overflowY: 'auto' }}
                       shouldCollapse={({ name }) => name === 'root'}
            />
          </AttributeRow>
        </AttributeTable>
      )
    }
  }
}

export default Payload
